import React, { useContext, useState } from "react";
import { ButtonGroup, Button } from "@material-ui/core";
import { ReportAccountantContext } from "../../context/ReportAccountantContext";
import { notify } from "../../utils/notify";
import ModalLoading from "../../components/modalLoading/ModalLoading";
import api from "../../services/api";

const ButtonsXML = () => {
  const { year, mounth, selectionClients, setSelectionClients } = useContext(
    ReportAccountantContext
  );
  const [nfeInput, setNfeInput] = useState(false);
  const [nfeOutput, setNfeOutput] = useState(false);
  const [arq, setArq] = useState(false);
  const [loading, setLoading] = useState(false);

  const process = async () => {
    let IdNotificacao = null;
    try {
      setLoading(true);

      let error = false;

      if (!mounth || !mounth.id) {
        error = true;
        notify("O campo Mês é de preenchimento obrigatório.");
      }

      if (!year || !year.descricao) {
        error = true;
        notify("O campo Ano é de preenchimento obrigatório.");
      }

      if (!selectionClients || selectionClients.length < 1) {
        error = true;
        notify("Selecione pelo menos um cliente.");
      }

      if (!nfeInput && !nfeOutput && !arq) {
        error = true;
        notify("Selecione pelo menos um tipo de arquivo.");
      }

      if (error) return setLoading(false);

      const body = {
        clientes: selectionClients,
        nfeEntrada: nfeInput,
        nfeSaida: nfeOutput,
        arqContabil: arq,
        mes: mounth.id,
        ano: parseInt(year.descricao),
        IdNotificacao,
      };

      const { data: result } = await api.post("/rabbit", body);

      if (result.success) {
        notify("Processando arquivos.", true, "info");
      }

      setSelectionClients([]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("ERROR ButtonsAccountant process:", error);
    }
  };

  const download = async () => {
    try {
      setLoading(true);

      let error = false;

      if (!mounth || !mounth.id) {
        error = true;
        notify("O campo Mês é de preenchimento obrigatório.");
      }

      if (!year || !year.descricao) {
        error = true;
        notify("O campo Ano é de preenchimento obrigatório.");
      }

      if (!selectionClients || selectionClients.length < 1) {
        error = true;
        notify("Selecione pelo menos um cliente.");
      }

      if (!nfeInput && !nfeOutput && !arq) {
        error = true;
        notify("Selecione pelo menos um tipo de arquivo.");
      }

      if (error) return setLoading(false);

      const body = {
        ClientesCNPJs: selectionClients,
        NFeEntrada: nfeInput,
        NFeSaida: nfeOutput,
        ArqContabil: arq,
        Mes: mounth.id,
        Ano: parseInt(year.descricao),
      };

      const { data: result } = await api.post(
        "/relatorio/contador/downloads",
        body
      );

      let downloadExecuted = false;

      if (result.success) {
        for (const element of result.data) {
          const saida = executeDownload(
            element.NFeSaida,
            `NFeSaida-${element.ClienteCNPJ}.zip`
          );
          if (!downloadExecuted) downloadExecuted = saida;

          const entrada = executeDownload(
            element.NFeEntrada,
            `NFeEntrada-${element.ClienteCNPJ}.zip`
          );
          if (!downloadExecuted) downloadExecuted = entrada;

          const contabil = executeDownload(
            element.ArqContabil,
            `ArqContabil-${element.ClienteCNPJ}.zip`
          );
          if (!downloadExecuted) downloadExecuted = contabil;
        }

        if (!downloadExecuted) {
          notify(
            "Nenhum arquivo foi enontrado para os clientes e o período selecionado.",
            true,
            "warning"
          );
        }
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("ERROR ButtonsAccountant download:", error);
    }
  };

  const executeDownload = (fileBase64, name) => {
    if (fileBase64 && typeof fileBase64 === "string") {
      try {
        var element = document.createElement("a");
        element.setAttribute(
          "href",
          "data:application/octet-stream;base64," +
            encodeURIComponent(fileBase64)
        );
        element.setAttribute("download", name);

        element.style.display = "none";
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);

        return true;
      } catch (error) {
        console.error("ERROR ButtonsAccountant executeDownload:", error);
        return false;
      }
    }
  };

  return (
    <div className="container-buttons-xml">
      {loading && <ModalLoading loading={loading} />}
      <div className="container-button-group">
        <span>Selecione os tipos de arquivo</span>
        <ButtonGroup
          className="button-group"
          size="large"
          variant="contained"
          color="primary"
          aria-label="contained primary button group"
        >
          <Button
            className={nfeOutput ? "button-option-select" : "button-option"}
            onClick={() => setNfeOutput(!nfeOutput)}
          >
            NFe Saída
          </Button>
          <Button
            className={nfeInput ? "button-option-select" : "button-option"}
            onClick={() => setNfeInput(!nfeInput)}
          >
            NFe Entrada
          </Button>
          <Button
            className={arq ? "button-option-select" : "button-option"}
            onClick={() => setArq(!arq)}
          >
            Arq. Contabil
          </Button>
        </ButtonGroup>
      </div>

      <div>
        <Button
          className="button-process"
          variant="contained"
          onClick={process}
        >
          Processar Arquivos
        </Button>

        <Button
          color="default"
          className={"button-download"}
          variant="contained"
          onClick={download}
        >
          Baixar Arquivos
        </Button>
      </div>
    </div>
  );
};

export default ButtonsXML;
